function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(89.019608%,30.980392%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 10.539062 68.28125 L 4.453125 0 L 71.398438 0 L 65.3125 68.28125 L 37.851562 76 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.72549%,39.607843%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 38 70.0625 L 60.117188 63.976562 L 65.3125 5.492188 L 38 5.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.156863%,92.156863%,92.156863%)",
      fillOpacity: 1
    },
    d: "M 38 30.875 L 26.867188 30.875 L 26.125 22.265625 L 38 22.265625 L 38 13.953125 L 16.921875 13.953125 L 19.148438 39.335938 L 38 39.335938 Z M 37.851562 52.695312 L 28.5 50.171875 L 27.90625 43.492188 L 19.59375 43.492188 L 20.632812 56.703125 L 37.851562 61.453125 Z M 37.851562 52.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 37.851562 30.875 L 37.851562 39.335938 L 48.242188 39.335938 L 47.203125 50.171875 L 37.851562 52.695312 L 37.851562 61.453125 L 55.070312 56.703125 L 57.445312 30.875 Z M 37.851562 13.953125 L 37.851562 22.265625 L 58.1875 22.265625 L 58.929688 13.953125 Z M 37.851562 13.953125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.a1f7aafbb95c0cb236babbe083b5b1a1.svg";
export { ForwardRef as ReactComponent };